import { AxiosPromise } from 'axios'
import { http } from '../http/http'

/**
 * @export FiltersApi - Just an api interface for claiming filters data and reducing the code needed for axios http functions
 * @class FiltersApi
 */
export class FiltersApi {
    /**
     * Base Url for User Api
     * @static
     * @type {string}
     * @memberof FiltersApi
     */
    static USER_BASE_URL: string = process.env.SMARTLY_BASE_URL_BE

    /**
     * Endpoint for user info
     * @static
     * @type {string}
     * @memberof FiltersApi
     */
    static FILTERS_LIST: string = '/filtersapi/filters'

    static getApiUrl(url: string, baseUrl: string = FiltersApi.USER_BASE_URL) {
        return `${baseUrl}${url}`
    }

    /**
     * This functions get saved filters list for the current user
     * @returns Promise of type AxiosPromise
     */
    static getFiltersList = async (
        isInitSession?: boolean,
        filterId?: string,
        baseUrl?: string
    ): Promise<any> => {
        return http.get<any>(
            `${FiltersApi.getApiUrl(
                FiltersApi.FILTERS_LIST,
                baseUrl
            )}?isInitSession=${isInitSession ? 'true' : 'false'}${
                filterId ? `&id=${filterId}` : ''
            }`
        )
    }
}
